import React, { useEffect, useState } from 'react'
import RenderField from './RenderField'
import { useLocation } from 'react-router-dom';
import { ServerRequestProtectedWithoutToken } from '../../../utils/ServerDataRequest';
import { enumUtil } from '../../../utils/Enum';
import Loader from '../../shared/Loader/Loader';
import NotificationHandler from '../../../utils/NotificationHandler';
import LogoRef from '../../../assets/img/logoRef.png';
import FormValidator from '../../../utils/FormValidator';
import SuperSearchList from '../../shared/SuperSearch/SuperSearchList';
import { formatFax } from '../../../utils/Formatting';
import FormatPhoneNumber from '../../../utils/FormatPhoneNumber';
import isNull from '../../../utils/NullChecking';
import { Separator } from '../utils/utils';

const IntakeFormViewer = () => {
    const location = useLocation();
    // Create a URLSearchParams instance using location.search
    const queryParams = new URLSearchParams(location.search);
    // Access specific query parameters
    const ID = queryParams.get('id');
    const API_URL = enumUtil.controller.EHRTemplate;
    let valModal = {}
    let ValidationModal = {
        OTPVal: "",
    }
    const [intakeFormValidationModal, setIntakeFormValidationModal] = useState(ValidationModal);
    const IntakeFormValidation = async () => {
        let ValidationModal = {
            OTPVal: FormValidator(
                formData?.OTP,
                enumUtil.enumValidationType.Required,
                'OTP',
            ),
        }
        await setIntakeFormValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    let FORM_DATA = {
        TemplateName: "",
        TemplateType: "",
        OTP: "",
        GuidID: ID,
        PatientName: ""
    }
    const [isLoading, setIsLoading] = useState(false);
    const [practiceData, setPracticeData] = useState({})
    const [formData, setFormData] = useState(FORM_DATA);
    const [isFormSubmitted, setIsFormSubmitted] = useState(false)
    const [data, setData] = useState([])
    console.log("IntakeFormViewer?.data", data)

    let valItemsModal = {}
    let ValidationItemsModal = {
    }
    const getItemType = (itemID) => {
        if (!itemID) return '';
        return itemID.split(/[-_:]/)[0];
    };
    const validateItemByType = (item, formData) => {
        const type = getItemType(item.ItemID);
        const isRequired = item.isRequired === "true" || item.isRequired === true;

        let validation = { isInvalid: false, message: "" };

        switch (type) {
            case "SimpleQuestion":
            case "Date":
            case "YesNoQuestion":
                {
                    let val = {
                        isInvalid: false,
                        options: false,
                        optionsError: "",
                        optionValidations: [],
                    };

                    const value = item.answer ?? "";

                    if (isRequired && !value) {
                        val.isInvalid = true;
                    }

                    validation = val;
                    break;
                }

            case "SingleChoice":
            case "MultiChoice":
            case "Dropdown":
            // case "Checklist":
            case "CheckList":
                {
                    const optionsArray = item.selectedOptions ? item.selectedOptions.split(Separator) : [];
                    console.log("SingleChoiceMultiChoiceDropdownCheckList", type, optionsArray)

                    let hasEmptyHintText = false; // flag if selected option has missing hint/value
                    let hasSelection = false;     // any option selected (contains (D))

                    const optionValidations = optionsArray.map(opt => {
                        const isSelected = opt.includes("(D)");
                        if (!isSelected) return false; // only validate selected options

                        hasSelection = true;

                        const metaMatch = opt.match(/\[(.*?)\]/)?.[1] || "";

                        // Extract TR, hintText, and typed value
                        const trFlag = metaMatch.match(/TR=(true|false)/)?.[1] ?? "false";
                        // const hintText = metaMatch.match(/hintText='(.*?)'/)?.[1] ?? "";
                        const typedValue = metaMatch.match(/value='(.*?)'/)?.[1] ?? "";

                        // Option is invalid if TR=true and BOTH hintText and typed value are empty
                        const isInvalid = trFlag === "true"
                            // && !hintText.trim() 
                            && !typedValue.trim();

                        if (isInvalid) hasEmptyHintText = true;

                        return isInvalid; // per-option invalid flag
                    });

                    const isInvalid =
                        (isRequired && !hasSelection) ||   // field-level required check
                        (hasSelection && hasEmptyHintText); // selected option TR + hint/value validation

                    validation = {
                        isInvalid, // overall field invalid
                        options: hasEmptyHintText, // option-level error flag
                        optionsError: hasEmptyHintText
                            ? "This Field Is Required!"
                            : "",
                        optionValidations, // array of true/false per option
                    };

                    break;
                }

            case "Table": {
                console.log("Table12345", item)
                const rowsArray = (typeof item.rows === "string" ? item.rows.split("\n") : item.rows ?? []);
                // Simple invalid check: any empty cell in any row
                const hasEmptyCell = rowsArray.some(row => (row || "").split(Separator).some(el => el.trim() === ""));

                if (isRequired && (rowsArray.length === 0 || hasEmptyCell)) {
                    validation = { isInvalid: true, message: "Table must have all cells filled" };
                }

                break;
            }

            case "Image":
            case "Signature": {
                // Image-specific validation logic
                const hasFile = !!item.file || (formData?.IsDefaultSignature);
                if (isRequired && !hasFile) {
                    validation = { isInvalid: true, message: `${type} is required` };
                }
                break;
            }

            default:
                break;
        }

        return validation;
    };
    const validateAllItems = (items, formData) => {
        const validationResult = {};

        (items || []).forEach(item => {
            const key = item.ItemID;
            validationResult[key] = validateItemByType(item, formData);
        });

        return validationResult;
    };
    const ValidationItems = async () => {
        const items = data?.[0]?.items;
        const ValidationItemsModal = validateAllItems(items, formData);

        await setValidationItemsModal(ValidationItemsModal)
        valItemsModal = ValidationItemsModal
    }
    const [validationItemsModal, setValidationItemsModal] = useState(ValidationItemsModal);

    const handleSetDefaultItemsForValidation = (Data) => {
        setValidationItemsModal(() => {
            return (Data || []).reduce((acc, item) => {
                acc[item.ItemID] = "";
                return acc;
            }, {});
        }
        );
    }
    console.log("validationItemsModalABC", validationItemsModal)
    const LoadData = (id) => {
        setIsLoading(true);
        setData([]);
        ServerRequestProtectedWithoutToken(API_URL + "/FindByGUIDID", 'post', {
            "TableName": enumUtil.enumAPITableName.PatientIntakeForm,
            "Value": id
        }).then((response) => {
            let { Data, EHRTemplateID, PracticeData, ...formData } = { ...response };
            setData(Data);
            handleSetDefaultItemsForValidation(Data?.[0]?.items || []);
            setFormData(prev => ({ ...prev, ...formData }))
            PracticeData && setPracticeData({ ...PracticeData[0] });
            setIsLoading(false);
        }).catch((error) => {
            console.log("ERROR", error)
            // This form is no longer available
            // This form has been removed and is no longer accessible.
            NotificationHandler("This form has been removed and is no longer accessible.", enumUtil.enumtoaster.error);
            setIsLoading(false);
        })
    }

    useEffect(() => {
        if (ID) {
            setFormData(prev => ({ ...prev, GuidID: ID }))
            LoadData(ID);
        }
    }, [ID])

    const handleSubmit = async () => {
        await ValidationItems();
        const validationItems = Object.values(valItemsModal).some(key => key.isInvalid);
        if (validationItems) {
            return
        } else {
            await IntakeFormValidation();
            let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
            if (validation) {
                // NotificationHandler('OTP is required. Please enter the code to proceed.', enumUtil.enumtoaster.error)
                return
            } else {
                setIsLoading(true);
                // console.log("Data",data,formData)
                // OTP : '637428',
                let saveModal = {
                    ...formData,
                    PracticesID: String(practiceData?.PracticesID || ""),
                    Data: [...data]
                }
                // console.log("saveModal",saveModal)
                ServerRequestProtectedWithoutToken(API_URL + "/SavePatientIntakeForm", 'post', {
                    ...saveModal
                }).then((response) => {
                    setIsLoading(false);
                    setIsFormSubmitted(true);
                    // NotificationHandler("Form submitted successfully", enumUtil.enumtoaster.success);
                }).catch((error) => {
                    console.log("ERROR", error)
                    setIsLoading(false);
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error);
                })
            }
        }
    }
    const handleClear = () => {
        setPracticeData({});
        setFormData(FORM_DATA);
        setData([]);
        setIntakeFormValidationModal(ValidationModal);
        LoadData(ID);
    }

    const formatAddress = (data) => {
        // Format >>>>> Address
        // >>>>>>>>>>>> City, State ZIP

        if (!data) return "";

        const { PracticeAddress, PracticeCity, PracticeState, PracticeZipCode } = practiceData;

        // First line → Address
        const line1 = PracticeAddress || "";
        // const line1 = practiceData?.Address || "";

        // Second line → City, State ZIP
        const cityStateZip = [PracticeCity, [PracticeState, PracticeZipCode].filter(Boolean).join(" ")].filter(Boolean).join(", ");

        // Combine with line break if both exist
        if (line1 && cityStateZip) return `${line1}<br />${cityStateZip}`;
        return line1 || cityStateZip || "";
    };
    const address = formatAddress(data);

    return (
        <>
            {isLoading ? <Loader /> : null}
            {data.length > 0 &&
                (
                    <>
                        <div className='ar_pat-info-form-fill d-flex justify-content-center'>
                            <div className="ar_fill-content-box d-flex flex-column gap-10">
                                <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5 practice-info">
                                    <div className="">
                                        <img src={practiceData?.img} alt="" style={{ maxHeight: '55px' }} />
                                    </div>
                                    <div className="text-center">
                                        {practiceData?.PracticeName ? <p className='heading text-black fs-16'>{practiceData?.PracticeName}</p> : ''}
                                        {address && (
                                            <p className="text text-black fs-14" dangerouslySetInnerHTML={{ __html: address }} />
                                        )}
                                    </div>
                                    <div className="d-flex gap-10">
                                        <div className="">
                                            <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                            <p className='text text-black font-m fs-14'>Fax:</p>
                                        </div>
                                        <div className="">
                                            <p className='text text-black  pb-2px fs-14'>{!isNull(practiceData?.Phone) ? FormatPhoneNumber(practiceData?.Phone) : practiceData?.Phone || 'N/A'}</p>
                                            <p className='text text-black fs-14'>{formatFax(practiceData?.fax) || 'N/A'}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-white">
                                    <p className="heading fs-16 lh-17 text-white form-heading">{formData?.TemplateName}</p>
                                    {["Submitted", "Processed"].includes(formData?.Status) ? <></> :
                                        <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>}
                                </div>

                                <div className="ar_star-form-Preview ar-intake-form-fill">
                                    <div className="Form-content d-flex flex-column gap-10 pe-1 hover-scrollbar">
                                        {console.log("formDataTemplateType", formData?.TemplateType, data?.[0]?.key)}
                                        {formData?.Status === "Awaiting Response" ?
                                            (!isFormSubmitted ?
                                                <></> :
                                                <div className='sucsses_meessage d-flex align-items-center gap-20 m-0'>
                                                    <div>
                                                        <i className='icon-tick-mark fs-49'></i>
                                                    </div>
                                                    <div >
                                                        <p className='fs-22 text font-m green_Color'>Form Submission Successful!</p>
                                                        <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                                    </div>
                                                </div>) : <></>}
                                        {["Submitted", "Processed"].includes(formData?.Status) ?
                                            (<div className='sucsses_meessage d-flex align-items-center gap-20 m-0'>
                                                <div>
                                                    <i className='icon-tick-mark fs-49'></i>
                                                </div>
                                                <div >
                                                    <p className='fs-22 text font-m green_Color'>This form is already submitted.</p>
                                                    {formData?.SubmittedBy === "Admin" ?
                                                        <p className='text fs-14'>This form has already been submitted on your behalf. If you need to update any information, contact us.</p>
                                                        :
                                                        <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                                    }

                                                </div>
                                            </div>) :
                                            (!isFormSubmitted &&
                                                <>
                                                    {data[0]['items'].map(it => {
                                                        return <RenderField item={it} setItem={setData} validations={validationItemsModal?.[it?.ItemID]} activeAccordion={data?.[0]?.key || 'Intake Form'} patientName={formData?.PatientName} formData={formData} setFormData={setFormData} />
                                                    })}
                                                    <div className='ar_OTP-section d-flex flex-column gap-10'>
                                                        <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                                        <div className='px-2 '>
                                                            <p className={`text font-m ar-light-color fs-13 pb-3px ${intakeFormValidationModal.OTPVal ? 'error-text' : ''}`}>Enter OTP here</p>
                                                            <div className={`input mb-0 w-25 ${intakeFormValidationModal.OTPVal ? 'error' : ''}`}>
                                                                <input
                                                                    type="text"
                                                                    className="form-control h-28"
                                                                    value={formData?.OTP}
                                                                    onChange={(e) => setFormData(prev => ({ ...prev, OTP: e.target.value }))}
                                                                />
                                                                {intakeFormValidationModal.OTPVal}
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                                        <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' onClick={handleSubmit}>Submit Form</button>
                                                        <p className='btn btn-outline  px-10 h-100 dark-clr' onClick={handleClear}>Clear Form</p>
                                                    </div>
                                                </>)}

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className='ar_intake-form d-flex flex-column align-items-center'>
                            <div className='ar_intake-form-viewer d-flex flex-column'>
                                <div className='d-flex align-items-center justify-content-between mb-30 ar_header'>
                                    <a href="https://starhealthcare.co/" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                        <div>
                                            <img src={LogoRef} alt="" height="125px" />
                                        </div>
                                    </a>
                                    <div className='d-flex flex-column gap-1'>
                                        {practiceData?.PracticeName ? <p className='heading fs-16 ar-dark-color ps-1-5'>{practiceData?.PracticeName}</p> : ''}
                                        {practiceData?.Address ? <p className='text fs-14 ar-dark-color d-flex align-items-center gap-5'><i className='icon-Location-on1 ar-dark-color fs-24'></i> {practiceData?.Address}</p> : ''}
                                        <div className='d-flex align-items-center gap-40'>
                                            {practiceData?.EmailAddress ? <p className='text fs-14 ar-dark-color d-flex align-items-center gap-5'> <i className='icon-Email1 ar-dark-color fs-24'></i>{practiceData?.EmailAddress}</p> : ''}
                                            {practiceData?.Phone ? <p className='text fs-14 ar-dark-color d-flex align-items-center gap-5'><i className='icon-Call1 ar-dark-color fs-24'></i> {practiceData?.Phone}</p> : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className='intake-heading'>
                                    <p className='fs-22 heading text-white'>{formData?.TemplateName || 'Patient Intake Form'}</p>
                                </div>
                                {formData?.Status === "Awaiting Response" ?
                                    (!isFormSubmitted ?
                                        <div className='mb-15 intake-paraghraph'>
                                            <p className='text text-black fs-14'>Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>
                                        </div> :
                                        <div className='sucsses_meessage d-flex align-items-center gap-20'>
                                            <div>
                                                <i className='icon-tick-mark fs-49'></i>
                                            </div>
                                            <div >
                                                <p className='fs-22 text font-m green_Color'>Form Submission Successful!</p>
                                                <p className='text fs-14'>Thank you for submitting the form. If you need further assistance, feel free to contact us.</p>
                                            </div>
                                        </div>) : <></>}
                                {formData?.Status === "Submitted" ?
                                    (<div className='sucsses_meessage d-flex align-items-center gap-20'>
                                        <div>
                                            <i className='icon-tick-mark fs-49'></i>
                                        </div>
                                        <div >
                                            <p className='fs-22 text font-m green_Color'>This intake form is already submitted.</p>
                                            <p className='text fs-14'>We've received your response. If you need further assistance, feel free to contact us.</p>
                                        </div>
                                    </div>) :
                                    (!isFormSubmitted &&
                                        <div>
                                            <div className='form_content d-flex flex-column gap-15 bg-white'>
                                                {data[0]['items'].map(it => {
                                                    return <RenderField item={it} setItem={setData} activeAccordion={data?.[0]?.key || 'Intake Form'} />
                                                })}
                                            </div>
                                            <div className='ar_OTP-section d-flex flex-column gap-10'>
                                                <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                                <div className='px-2 '>
                                                    <p className={`text font-m ar-light-color fs-13 pb-3px ${intakeFormValidationModal.OTPVal ? 'error-text' : ''}`}>Enter OTP here</p>
                                                    <div className={`input mb-0 w-25 ${intakeFormValidationModal.OTPVal ? 'error' : ''}`}>
                                                        <input
                                                            type="text"
                                                            className="form-control h-28"
                                                            value={formData?.OTP}
                                                            onChange={(e) => setFormData(prev => ({ ...prev, OTP: e.target.value }))}
                                                        />
                                                        {intakeFormValidationModal.OTPVal}
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between align-items-center footer-btn'>
                                                    <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' onClick={handleSubmit}>Submit Form</button>
                                                    <p className='orange-drk lh-normal fs-14 text font-m text-decoration-underline cursor-pointer' onClick={handleClear}>Clear Form</p>
                                                </div>
                                            </div>
                                        </div>)}
                            </div >
                        </div> */}

                        {/* Release of Information Form */}

                        {/* <div className='ar_pat-info-form-fill d-flex justify-content-center'>
                            <div className="ar_fill-content-box d-flex flex-column gap-16">
                                <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5">
                                    <div className="">
                                        <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                    </div>
                                    <div className="text-center">
                                        <p className='heading text-black fs-16'>NORTHWEST FLORIDA</p>

                                        <p className="text text-black fs-14"> 8009 Savannah Rd, Katerpiller Lane Street <br />
                                            Sanersvile, GA, 13082-4040</p>

                                    </div>
                                    <div className="d-flex gap-10">
                                        <div className="">
                                            <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                            <p className='text text-black font-m fs-14'>Fax:</p>
                                        </div>
                                        <div className="">
                                            <p className='text text-black  pb-2px fs-14'>+1 99 9999 999</p>
                                            <p className='text text-black fs-14'>+1 99 9999 999</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-white">
                                    <p className="heading fs-16 lh-17 text-white form-heading">Release of Information Form</p>
                                    <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>
                                </div>
                                <div className="ar_star-form-Preview">
                                    <div className="Form-content d-flex flex-column gap-16 pe-1 hover-scrollbar">
                                        <div className="">
                                            <div className="pateint-information mb-10">
                                                <div className="d-flex align-items-center gap-1">
                                                    <p className="heading fs-14 text-black min-w-85px">Albert, Rins</p>
                                                    <p className='text fs-13 text-black'>10/10/2002</p>
                                                    <p className='text fs-13 text-black'>(34 Y)</p>
                                                    <p className='text fs-13 text-black'>Male</p>
                                                </div>
                                                <div className="d-flex align-items-center gap-1">
                                                    <p className="heading fs-13 font-m text-black min-w-85px">Phone #</p>
                                                    <p className='text fs-13 text-black'>(000) 000 0000</p>
                                                </div>
                                                <div className="d-flex align-items-center gap-1">
                                                    <p className="heading fs-13 font-m text-black min-w-85px">Address:</p>
                                                    <p className='text fs-13 text-black'>47 Houston RD STE 400 Spring, Texas, 77039</p>
                                                </div>
                                            </div>
                                            <p className="text text-black fs-13">I, authorize health care provider or practice mentioned in item 2 to use or disclose following information mentioned in item 5 to the above named patient:</p>
                                        </div>

                                        <div className="">
                                            <p className="heading text-black fs-14 mb-1">2. Healthcare Provider/Practice (Information Holder)</p>
                                            <p className='text text-black'>NORTHWEST FLORIDA</p>
                                            <p className="text text-black"> <span className="font-m">Address:</span> 8009 Savannah Rd, Katerpiller Lane Street <br /> Sanersvile, GA, 13082-4040</p>
                                        </div>

                                        <div className="">
                                            <p className="heading text-black fs-14 mb-1">3. Recipient (To Whom Information will be Shared)</p>
                                            <p className='text text-black'>NORTHWEST FLORIDA</p>
                                            <p className="text text-black"> <span className="font-m">Address:</span> 8009 Savannah Rd, Katerpiller Lane Street <br /> Sanersvile, GA, 13082-4040</p>
                                        </div>

                                        <div className="">
                                            <p className="heading text-black fs-14 mb-1">4. Purpose of Disclosure</p>
                                            <p className='text text-black'>The information may be shared to support your care, treatment, or billing needs. It may also be used for legal, insurance, or personal purposes as requested.</p>
                                        </div>

                                        <div className="">
                                            <p className="heading text-black fs-14 mb-1">5. Information to be Released</p>
                                            <div className="custom_check_box d-flex gap-6 mb-1">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0 mt-3px"
                                                    name='IsAutoSubmittion'
                                                    id='IsAutoSubmittion'
                                                />
                                                <div className="">
                                                    <p className="text fs-12 text-black user-select-none">Complete Medical Record, including:</p>
                                                    <p className="text fs-12 text-black ar_dot">Patient Histories</p>
                                                    <p className="text fs-12 text-black ar_dot">Lab Results</p>
                                                    <p className="text fs-12 text-black ar_dot">Radiology Studies/FilmsReferrals</p>
                                                    <p className="text fs-12 text-black ar_dot">Consults</p>
                                                    <p className="text fs-12 text-black ar_dot">Patient Histories</p>
                                                    <p className="text fs-12 text-black ar_dot">Billing RecordsInsurance Records</p>
                                                    <p className="text fs-12 text-black ar_dot">Other</p>
                                                </div>
                                            </div>

                                            <div className="custom_check_box d-flex align-items-center gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    name='IsAutoSubmittion'
                                                    id='IsAutoSubmittion'
                                                />
                                                <p className="text fs-12 text-black user-select-none">Alcohol/Drug Treatment, Mental Health Information and HIV-Related Information.</p>
                                            </div>


                                        </div>

                                        <div className="">
                                            <p className="heading text-black fs-14 mb-1">6. Patient Rights/Authorization</p>
                                            <div className="d-flex flex-column gap-1 ps-2">
                                                <p className="text fs-12 text-black ar_dot">I may revoke this authorization at any time by contacting to the healthcare provider listed above.</p>
                                                <p className="text fs-12 text-black ar_dot">I understand that I cannot revoke this authorization for information that has already been released.</p>
                                                <p className="text fs-12 text-black ar_dot">Information disclosed under this authorization might be redisclosed by the recipient, and this redisclosure may no longer be protected by federal or state law.</p>
                                            </div>
                                        </div>

                                        <div className="">
                                            <p className="heading text-black fs-14 mb-1">7. Expiration/Revocation</p>

                                            <div className="">
                                                <p className="text fs-12 text-black">This authorization will remain in effect until it is revoked by contacting the practice.</p>
                                                <p className="text fs-12 text-black ar_dot ps-2">
                                                    I understand that I can revoke this authorization at any time prior to that date. Revocation will not apply to information that has already been released based on this authorization.</p>
                                            </div>
                                        </div>

                                        <div className="">
                                            <p className="heading text-black fs-14 mb-1">8. Signature Authorization</p>

                                            <div className="d-flex flex-column gap-5">
                                                <p className="text fs-12 text-black">I consent that my electronic signature below has the same legal effect as a handwritten signature for purposes of validity.</p>
                                                <div className="content-box">
                                                    <div className="d-flex gap-10 align-items-center">
                                                        <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                                            Patient Signature<span className="text font-m Denied-clr fs-14">*</span>
                                                        </p>
                                                        <div className="form-control cursor-pointer d-flex align-items-center">
                                                            <p className="text ar-light-color user-select-none">Click to sign here</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="">
                                            <div className='ar_OTP-section d-flex flex-column gap-10'>
                                                <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                                <div className='px-2  content-box'>
                                                    <p className='text font-m ar-light-color fs-13 pb-3px'>Enter OTP here</p>
                                                    <div className={`input mb-0 w-50 `}>
                                                        <input
                                                            type="text"
                                                            className="form-control h-28 za_br_light"
                                                            name="OTP"
                                                            id="OTP"
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                                <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' >Submit Form</button>
                                                <button className='btn btn-outline  px-10 h-100 dark-clr'>Clear Form</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* Credit Card Authorization Form */}

                        {/* <div className='ar_pat-info-form-fill d-flex justify-content-center'>
                            <div className="ar_fill-content-box d-flex flex-column gap-16">
                                <div className="d-flex align-items-center justify-content-between bg-white br-bottom-1 za_br_light pb-1-5">
                                    <div className="">
                                        <img src={LogoRef} alt="" style={{ maxHeight: '55px' }} crossOrigin="anonymous" />
                                    </div>
                                    <div className="text-center">
                                        <p className='heading text-black fs-16'>NORTHWEST FLORIDA</p>

                                        <p className="text text-black fs-14"> 8009 Savannah Rd, Katerpiller Lane Street <br />
                                            Sanersvile, GA, 13082-4040</p>

                                    </div>
                                    <div className="d-flex gap-10">
                                        <div className="">
                                            <p className='text text-black font-m fs-14 pb-2px'>Tel:</p>
                                            <p className='text text-black font-m fs-14'>Fax:</p>
                                        </div>
                                        <div className="">
                                            <p className='text text-black  pb-2px fs-14'>+1 99 9999 999</p>
                                            <p className='text text-black fs-14'>+1 99 9999 999</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-white">
                                    <p className="heading fs-16 lh-17 text-white form-heading">Release of Information Form</p>
                                    <p className="text fs-12 lh-14 form-instruction p-2">Please fill out all fields as accurately as possible. This information helps us provide you with the best care. If you need any assistance with completing this form, please don't hesitate to contact us.</p>
                                </div>
                                <div className="ar_star-form-Preview">
                                    <div className="Form-content d-flex flex-column gap-16 pe-1 hover-scrollbar">
                                        <div className="">
                                            <p className="heading fs-14 text-black mb-1">Credit Card Authorization</p>
                                            <p className="text text-black">Please complete all required fields below. By submitting this form, you authorize us to securely store your payment information and charge your card as described in this agreement.</p>
                                        </div>

                                        <div className="primary-insurance-content">
                                            <div className="content-box d-flex flex-column gap-10">
                                                <div className="d-flex gap-10 align-items-center">
                                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                                        Card Holder Name <span className="text font-m Denied-clr fs-14">*</span>
                                                    </p>
                                                    <div className='input w-100'>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="SSN"
                                                            id="SSN"
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex gap-10">
                                                    <p className='text fs-14 text-black min-w-156px d-flex justify-content-end gap-01'>
                                                        Card Type <span className="text font-m Denied-clr fs-14">*</span>
                                                    </p>
                                                    <div className='d-flex gap-4 flex-wrap row-gap-5'>
                                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name='IsAutoSubmittion'
                                                                id='IsAutoSubmittion'
                                                            />
                                                            <p className="text fs-14 text-black user-select-none">Visa</p>
                                                        </label>
                                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name='IsAutoSubmittion'
                                                                id='IsAutoSubmittion'
                                                            />
                                                            <p className="text fs-14 text-black user-select-none">Master Card</p>
                                                        </label>
                                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name='IsAutoSubmittion'
                                                                id='IsAutoSubmittion'
                                                            />
                                                            <p className="text fs-14 text-black user-select-none">Discover</p>
                                                        </label>
                                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name='IsAutoSubmittion'
                                                                id='IsAutoSubmittion'
                                                            />
                                                            <p className="text fs-14 text-black user-select-none">American Express</p>
                                                        </label>
                                                        <label className="custom_check_box d-flex align-items-center gap-6">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input m-0 p-0"
                                                                name='IsAutoSubmittion'
                                                                id='IsAutoSubmittion'
                                                            />
                                                            <p className="text fs-14 text-black user-select-none">Other</p>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="d-flex gap-10 align-items-center">
                                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                                        Card Number <span className="text font-m Denied-clr fs-14">*</span>
                                                    </p>
                                                    <div className='input w-100'>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="SSN"
                                                            id="SSN"
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex gap-10 align-items-center">
                                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                                        Expiration Date <span className="text font-m Denied-clr fs-14">*</span>
                                                    </p>
                                                    <div className='input w-100'>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="SSN"
                                                            id="SSN"
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>

                                                <div className="d-flex gap-10 align-items-center">
                                                    <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                                        Security Code <span className="text font-m Denied-clr fs-14">*</span>
                                                    </p>
                                                    <div className='input w-100'>
                                                        <input type="text"
                                                            className='form-control'
                                                            name="SSN"
                                                            id="SSN"
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="">
                                            <p className="heading fs-14 text-black mb-1">Authorization</p>
                                            <label className="custom_check_box d-flex gap-6">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0 mt-1"
                                                    name='IsAutoSubmittion'
                                                    id='IsAutoSubmittion'
                                                />
                                                <p className="text text-black user-select-none">I, <span className="heading text-black">Patient Name,</span> authorize <span className="heading text-black">Practice Name</span> to charge the credit card listed above for agreed-upon services, balances, copayments, deductibles, cancellation fees, and other charges related to my account. I understand that this authorization will remain in effect until the expiration of the credit card account. I may revoke this authorization at any time by contacting to the practice name. Revocation will not apply to charges already processed. I consent that my electronic signature below has the same legal effect as a handwritten signature for purposes of validity.</p>
                                            </label>
                                        </div>

                                        <div className="content-box">
                                            <div className="d-flex gap-10 align-items-center">
                                                <p className='text fs-14 text-black min-w-156px d-flex align-items-center justify-content-end gap-01'>
                                                    Patient Signature<span className="text font-m Denied-clr fs-14">*</span>
                                                </p>
                                                <div className="form-control cursor-pointer d-flex align-items-center">
                                                    <p className="text ar-light-color user-select-none">Click to sign here</p>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="">
                                            <div className='ar_OTP-section d-flex flex-column gap-10'>
                                                <p className='Patient-Payment text fs-13 ar_text w-max-content'>We've sent a verification code to your email. Check the same email you used to open the intake form link.</p>
                                                <div className='px-2  content-box'>
                                                    <p className='text font-m ar-light-color fs-13 pb-3px'>Enter OTP here</p>
                                                    <div className={`input mb-0 w-50 `}>
                                                        <input
                                                            type="text"
                                                            className="form-control h-28 za_br_light"
                                                            name="OTP"
                                                            id="OTP"
                                                            autoComplete="off"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center footer-btn px-10'>
                                                <button className='btn btn-orange h-auto submit-btn fs-14 font-sb' >Submit Form</button>
                                                <button className='btn btn-outline  px-10 h-100 dark-clr'>Clear Form</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                    </>
                )}
        </>
    )
}

export default IntakeFormViewer